import { ContentUsedProductCertificate } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetContentUsedProductCertificateResponse } from "../schema/GetContentUsedProductCertificateResponse";
import { mapUsedProductCertificate } from "../../mappers/usedProductCertificateMapper";

export const getContentUsedProductCertificateDetails = async (): Promise<ContentUsedProductCertificate> => {
    const client = ApiClient.getInstance()

    const response = await client.get<GetContentUsedProductCertificateResponse>(`content-product-used-certificate/details/`)

    const mappedResponse = mapUsedProductCertificate(response.data)

    return mappedResponse;
}